import React, { useEffect, useState } from "react";
import "./VirasatDefaultV2PageWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import LeftDrawer from "./components/LeftDrawer/LeftDrawer";
import ComingSoonModal from "./components/ComingSoonModal/ComingSoonModal";
import { useSelector } from "react-redux";
import ValentinesModal from "./components/ValentinesModal/ValentinesModal";
import { useHistory } from "react-router";

const VirasatDefaultV2PageWrapper = ({ children }) => {
    const history = useHistory();
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const iscoming = useSelector((state) => state.companyData.isComing)
    const [openValentines, setOpenValentines] = useState(true)
    useEffect(() => {
        if (history.location.pathname === "/" || history.location.pathname === "/menu") {
            setOpenValentines(true);
        } else {
            setOpenValentines(false);
        }
    }, [history.location.pathname]);
    return (
        <div className="VirasatDefaultV2PageWrapper">
            <LeftDrawer
                isOpen={isMenuOpen}
                setIsOpen={setIsMenuOpen} />
            <Navbar
                setIsMenuOpen={setIsMenuOpen} />
            {children}
            {iscoming && <ComingSoonModal />}
            {openValentines && <ValentinesModal
                onClose={() => {
                    setOpenValentines(false)
                }} />}
            <Footer />
        </div>
    )
}
export default VirasatDefaultV2PageWrapper